var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-tab",style:(_vm.tabStyle)},[_c('div',{staticClass:"images"},[_c('img',{staticClass:"tab-image",attrs:{"src":_vm.tabImage}})])])}
var staticRenderFns = []

export { render, staticRenderFns }